'use client';
import { useCart } from '@/contexts/CartContext';

export default function ScarcitySection() {
  const { addToCart, inventory } = useCart();

  const handleAddToCart = () => {
    if (inventory > 0) {
      addToCart({
        id: 'igniss-001',
        name: 'IGNISS // 001',
        price: 49,
        quantity: 1,
        image: 'https://images.unsplash.com/photo-1602874801006-e0c4c93c7c3c?w=400',
      });
    }
  };

  const isSoldOut = inventory === 0;

  return (
    <section className="py-32 px-6 bg-background reveal">
      <div className="max-w-5xl mx-auto text-center space-y-16">
        {/* Price */}
        <div className="space-y-6">
          <h2 className="text-6xl md:text-7xl font-serif font-bold tracking-tight leading-none text-foreground">
            IGNISS // 001 — <span className="text-primary">£49</span>
          </h2>
          
          <p className="text-xl md:text-2xl text-muted-foreground leading-relaxed">
            No discounts. No future drops. No restocks.
          </p>

          {/* Inventory Counter */}
          <p className="text-lg text-primary font-semibold">
            {isSoldOut ? 'Sold Out' : `${inventory} units remaining`}
          </p>
        </div>

        <div className="h-px w-24 mx-auto bg-border"></div>

        {/* Commitment */}
        <div className="max-w-2xl mx-auto space-y-6">
          <p className="text-lg text-muted-foreground leading-relaxed">
            Limited production run. Orders ship within 10–14 days. <br />
            Each unit quality-checked before dispatch.
          </p>
        </div>

        {isSoldOut ? (
          <div className="bg-muted text-muted-foreground px-12 py-6 rounded-full text-xl font-bold inline-block">
            Sold Out — Never Restocked
          </div>
        ) : (
          <button 
            onClick={handleAddToCart}
            className="bg-primary text-primary-foreground px-12 py-6 rounded-full text-xl font-bold hover:bg-foreground hover:text-background smooth-hover shadow-xl"
          >
            Add to Cart
          </button>
        )}
      </div>
    </section>
  );
}